define('app/dashboard/widgets/ScatterPlotDashboardItemView',['require','./ReportDashboardItemView','app/visualizations/ScatterPlot','hbs!./ScatterPlotDashboardItemView.hbs'],function(require) {

	'use strict';

	var ReportDashboardItemView = require('./ReportDashboardItemView'),
		ScatterPlot = require('app/visualizations/ScatterPlot');

	return ReportDashboardItemView.extend({
		className: 'dashboard-item dashboard-item-scatter-plot',
		template: require('hbs!./ScatterPlotDashboardItemView.hbs'),

		initialize: function() {
			// call base class initialize function
			ReportDashboardItemView.prototype.initialize.call(this);

			this.model.set('isLoading', true);
			this.listenTo(this.model, 'dataReceived', this.dataReceived);
			this.listenTo(this.model, 'change', this.render);
		},

		regions: {
			chartContainer: '.scatter-plot-container'
		},

		onRender: function() {
			this.chartView = new ScatterPlot({
				model: this.model,
				height: 300,
				width: 300,
				showLegend: false,
				showSubchart: false,
				showTicks: false,
				fixToolTips: true,
				paddingRight: 5,
				paddingLeft: 5
			});

			this.chartContainer.show(this.chartView);
		},

		dataReceived: function() {
			this.model.set('isLoading', false);
			this.render();
		},

		isLoading: function() {
			return this.model.get('isLoading');
		},

		onClose: function() {
			if (this.chartView) {
				this.chartView.close();
			}

			this.remove();
			this.unbind();
			this.model.unbind('change', this.modelChanged);
		}
	});
});

